'use client'
import {
  context_default
} from "./chunk-HDMRRVS3.mjs";
import {
  getCurrencyExchange,
  useGetCurrencyExchange
} from "./chunk-RFT2B4D6.mjs";
import {
  ABSOLUTE_FALLBACK_CURRENCY
} from "./chunk-WFHUYKGS.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-QB4ZOYYY.mjs";

// src/context/root/provider.tsx
import { useEffect, useMemo, useState } from "react";
import { createCookie, formatPrice } from "@wbk/utils";
import { jsx } from "react/jsx-runtime";
var CurrencyProvider = ({ children, detectedCurrency, currencies }) => {
  var _a;
  const [state, setState] = useState();
  const { data: exchangeRate } = useGetCurrencyExchange({
    currency: currencies.length > 0 && (state == null ? void 0 : state.currency) ? (_a = state == null ? void 0 : state.currency) == null ? void 0 : _a.toLowerCase() : ""
  });
  useEffect(() => {
    if (!currencies.length)
      return;
    const isSupported = currencies == null ? void 0 : currencies.some((c) => detectedCurrency === c.shortCode);
    const supported = isSupported ? detectedCurrency : ABSOLUTE_FALLBACK_CURRENCY.shortCode;
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { currency: supported }));
  }, [currencies, detectedCurrency]);
  const setCurrency = (currency2) => {
    createCookie({ name: "currency", value: currency2, expiration: 7 });
    setState((prevState) => __spreadProps(__spreadValues({}, prevState), { currency: currency2 }));
  };
  const currency = useMemo(() => {
    return (currencies == null ? void 0 : currencies.find((c) => c.shortCode === (state == null ? void 0 : state.currency))) || ABSOLUTE_FALLBACK_CURRENCY;
  }, [currencies, state == null ? void 0 : state.currency]);
  const exchangePrice = (price, currency2, format = true) => {
    if (!exchangeRate || !currency2) {
      return format ? formatPrice(price) : price;
    }
    const rate = exchangeRate[currency2.toLowerCase()] || 1;
    const result = price / rate;
    return format ? formatPrice(result) : result;
  };
  const unExchangePrice = (price, currency2, format = true) => {
    if (!exchangeRate || !currency2) {
      return format ? formatPrice(price) : price;
    }
    const rate = exchangeRate[currency2.toLowerCase()] || 1;
    const result = price * rate;
    return format ? formatPrice(result) : result;
  };
  const exchangePriceForCurrency = (price, original, target, format = true) => __async(void 0, null, function* () {
    try {
      const exchangeRate2 = yield getCurrencyExchange({ currency: original.toLowerCase() });
      if (!exchangeRate2) {
        return formatted(price, format);
      }
      const rate = exchangeRate2[target.toLowerCase()] || 1;
      const result = price * rate;
      return formatted(result, format);
    } catch (error) {
      return formatted(price, format);
    }
  });
  const formatted = (result, format) => {
    return format ? formatPrice(result) : result;
  };
  const symbol = useMemo(() => {
    return currency.symbol || currency.shortCode;
  }, [currency.symbol, currency.shortCode]);
  return /* @__PURE__ */ jsx(
    context_default.Provider,
    {
      value: {
        active: !!detectedCurrency,
        currencies,
        currency,
        symbol,
        setCurrency,
        exchangePrice,
        unExchangePrice,
        exchangePriceForCurrency
      },
      children
    }
  );
};

export {
  CurrencyProvider
};
//# sourceMappingURL=chunk-NNA3BLEM.mjs.map